
import {formValidation, plugins} from "./lib/formvalidation_1_8_1/es6/index";

import rteInit from './jq-rte-summernote-init';
import Bootstrap from "../../src-admin/lib/formvalidation_1.3.0/es6/plugins/Bootstrap";

import * as Ladda from 'ladda';
import _ from "underscore";
import './lib/jquery.form';

import zxcvbn from 'zxcvbn/dist/zxcvbn';

var zxcvbnGlob;

function ds81_init_autovalidator_form($form, callbackOnSuccess, callbackOnError) {

    // Zxcvbn to global scope:
    zxcvbnGlob = zxcvbn;
    var res = zxcvbnGlob('sdfgwerfwes');

    var form = $form.get(0);

    if($form.hasClass('form-init-done'))
    {
        return false;
    }

    $form.addClass('form-init-done');

    // Init default RTE:
    rteInit($form);


    // Add change handler to password meter fields:
    $form.find('input.has-password-meter').on('keydown', function (){
        if($(this).val() != $(this).data('nochange-marker'))
        {
            $(this).attr('data-was-changed', true).data('was-changed', true);
        }
    });

    // Storage for non auto-generated validators:
    var fields = {};

    // Check for auto-generated validation config:
    if(typeof dataStructureValidations !== "undefined")
    {
        fields = $.extend(fields, dataStructureValidations);
    }
    if(typeof $form.data('validations') !== "undefined")
    {
        var restoredFunctionsJson = JSON.parse(JSON.stringify($form.data('validations')), function(k,v){ return typeof v === "string"? (v.startsWith('function')? eval("("+v+")") : v): v});
        fields = $.extend(fields, restoredFunctionsJson);
    }

    var fv = formValidation(
            form,
            {
                fields: fields,
                plugins: {
                    trigger: new plugins.Trigger(),
                    bootstrap: new Bootstrap(),
                    submitButton: new plugins.SubmitButton(),
                    sequence: new plugins.Sequence({
                        enabled: true,
                    }),
                    declarative: new plugins.Declarative({
                        html5Input: false
                    }),
                    excluded: new plugins.Excluded({
                        excluded: function(field, element, elements) {


                            // Check if field is hidden:
                            if($(element).is(':hidden') && !$(element).next().hasClass('note-editor') && !$(element).parent().hasClass('upload-media-image') && !$(element).hasClass('validate-if-hidden'))
                            {
                                // console.log('field EX', field);
                                return true;
                            }

                            // Check if field is empty:
                            if($(element).data('fv-excluded-if-empty') === true)
                            {
                                // Enable validation if field has value:
                                if($(element).val().length > 0)
                                {
                                    return false;
                                }
                                else
                                {
                                    return true;
                                }
                            }
                            else
                            {
                                // Always required.
                                return false;
                            }
                        }
                    }),
                },
            })
        .on('core.form.valid', function() {

            var l = Ladda.create( $form.find('.btn-submit.ladda-button').get(0) );
            l.start();
            $form.data('myLadda', l);

            var data = {};

            // Prepare media file listing:
            var mediaList = {};
            $form.find('[class*="upload-media-"]').each(function () {
                var fieldName = $(this).data('listname');
                // console.log('found ' + fieldName);
                mediaList[fieldName] = {};
                var fieldIterator = 0;
                $(this).find('.item-list-target .upload-item').each(function () {
                    var nodeId = $(this).attr('data-itemid');
                    mediaList[fieldName][nodeId] = {};
                    mediaList[fieldName][nodeId] = {
                        'files' : {}
                    },
                        $(this).find('[data-fileid]').each(function () {
                            mediaList[fieldName][nodeId]['files'][fieldIterator ++] = {
                                'fileid': $(this).attr('data-fileid'),
                            };
                        });
                });
            });

            // Add medialist data:
            var data = _.extend(data, {medialist: mediaList});

            // Get teaser top crop position, if set:
            if($('.teaser-image-cropbox').length > 0)
            {
                var percentVal = typeof $('.teaser-image-cropbox').attr('data-top-percent') !== "undefined" ? Number.parseFloat($('.teaser-image-cropbox').attr('data-top-percent')) : Number.parseFloat($('.teaser-image-cropbox').attr('data-prefill'));
                var data = _.extend(data, {teaser_top_offset_percent: percentVal});
            }


            // Submit form:
            $form.ajaxSubmit({
                url: $form.attr('action'),
                dataType: 'json',
                method: 'post',
                data: data,
                success: function(responseData, statusText, xhr, $form) {

                    // TODO: Improve whole success handling!


                    if(responseData.result == 'ok')
                    {

                        // Stop ladda if no redirect request is set in response:
                        if(typeof responseData.redirect === "undefined")
                        {
                            l.stop();
                        }

                        // Update page fragments, if some:
                        if(typeof responseData.updateFragments !== "undefined")
                        {
                            for(var i in responseData.updateFragments)
                            {
                                FE.updatePageFragment(i, responseData.updateFragments[i]);
                            }
                        }


                        // Get server message:
                        if(typeof responseData.message !== "undefined")
                        {
                            var messageString = responseData.message;

                            // Show message:
                            if(typeof responseData.redirect === "undefined")
                            {
                                $form.find('.main-form-error-out').addTimedMessage('success', messageString, null, function () {
                                });
                            }
                            else
                            {
                                $form.find('.main-form-error-out').addTimedMessage('success', messageString, null, function () {
                                    location.href = responseData.redirect;
                                });
                            }

                        }
                        else
                        {

                            if(typeof responseData.redirect !== "undefined") {
                                location.href = responseData.redirect;
                            }
                            if(typeof responseData.redirect_from !== "undefined") {
                                location.href = $form.attr(responseData.redirect_from);
                            }
                        }

                        // Trigger success callback, if set:
                        if(typeof callbackOnSuccess === "function")
                        {
                            callbackOnSuccess($form, responseData);
                        }

                        // Form inside .form-content container inside a .form-content-block and .thankyou-content present?
                        // Show thankyou content.
                        if($form.parent().hasClass('form-content') && $form.parent().parent().hasClass('form-content-block') && $form.parent().parent().find('.thankyou-content').length > 0)
                        {
                            $form.parent().addClass('d-none');
                            $form.parent().parent().find('.thankyou-content').removeClass('d-none');
                        }

                    }
                    else {

                        if(typeof responseData.reload !== "undefined") {
                            location.reload();
                            return true;
                        }

                        // Get server error message:
                        if (typeof responseData.errormessage !== "undefined")
                        {
                            // Stop ladda;
                            l.stop();

                            // Get server error message:
                            var errorMessage = responseData.errormessage;

                            // Show message:
                            $form.find('.main-form-error-out').addTimedMessage('danger', errorMessage, 30000);

                        }
                        else if (typeof responseData.fielderrors !== "undefined")
                        {
                            // Stop ladda;
                            l.stop();


                            // Serverseitig erkannte Feldfehler bearbeiten (Fehler anzeigen):
                            for(var i in responseData.fielderrors)
                            {

                                if(responseData.fielderrors[i].length > 0)
                                {
                                    fv
                                    // Update the message option
                                        .updateValidatorOption(
                                            i, 'srv', 'message', responseData.fielderrors[i]
                                        )
                                        // Set the field as invalid
                                        .updateFieldStatus(i, 'Invalid', 'srv');

                                }
                            }

                        }
                        else
                        {
                            l.stop();

                            // Get server error message:
                            var errorMessage = $form.find('.main-form-error-out').data('message-servererror');

                            // Show message:
                            $form.find('.main-form-error-out').addTimedMessage('danger', errorMessage);

                        }

                    }


                },
                error: function(xhr, status, error, $form)
                {
                    // Stop ladda;
                    l.stop();

                    // Get server error message:
                    var errorMessage = $form.find('.main-form-error-out').data('message-servererror');

                    // Show message:
                    $form.find('.main-form-error-out').addTimedMessage('danger', errorMessage);


                    // Trigger error callback, if set:
                    if(typeof callbackOnError === "function")
                    {
                        callbackOnError($form, status, error);
                    }


                }
            });

        });

    $form.data('form-fv', fv);


}

export default (function ds81_initAutovalidatorForm($form, callbackOnSuccess) {
    ds81_init_autovalidator_form($form, callbackOnSuccess);
}, window.ds81_init_autovalidator_form = ds81_init_autovalidator_form);
